/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type infoUpdateShipmentFinanceInput = {
    clientMutationId?: string | null;
    slug: string;
    costWarehousing?: number | null;
    revenueWarehousing?: number | null;
    costDischarge?: number | null;
    revenueDischarge?: number | null;
    costTransport?: number | null;
    revenueTransport?: number | null;
    costCustomsInspection?: number | null;
    revenueCustomsInspection?: number | null;
    costClimaCertificate?: number | null;
    revenueClimaCertificate?: number | null;
    costOpinion?: number | null;
    revenueOpinion?: number | null;
    costContainerXray?: number | null;
    revenueContainerXray?: number | null;
    costContainerHandling?: number | null;
    revenueContainerHandling?: number | null;
    costShipping?: number | null;
    revenueShipping?: number | null;
    costCleaning?: number | null;
    revenueCleaning?: number | null;
    costSpecialHandling?: number | null;
    revenueSpecialHandling?: number | null;
    costStorage?: number | null;
    revenueStorage?: number | null;
    costForklift?: number | null;
    revenueForklift?: number | null;
    costOther?: number | null;
    revenueCustomsClearance?: number | null;
    costCustomsClearance?: number | null;
    customsDuties?: number | null;
    customsVat?: number | null;
    discount?: number | null;
    discountRemark?: string | null;
    receivedPayment?: number | null;
    costExpenses?: number | null;
    revenueExpenses?: number | null;
    handoverDate?: string | null;
    expectedHandoverDate?: string | null;
};
export type ShipmentFinanceDetailsMutationVariables = {
    input: infoUpdateShipmentFinanceInput;
};
export type ShipmentFinanceDetailsMutationResponse = {
    readonly infoUpdateShipmentFinance: {
        readonly clientMutationId: string | null;
        readonly shipment: {
            readonly " $fragmentRefs": FragmentRefs<"ShipmentFinanceDetails_shipment" | "ShipmentFinanceMetricCard_shipment">;
        };
    } | null;
};
export type ShipmentFinanceDetailsMutation = {
    readonly response: ShipmentFinanceDetailsMutationResponse;
    readonly variables: ShipmentFinanceDetailsMutationVariables;
};



/*
mutation ShipmentFinanceDetailsMutation(
  $input: infoUpdateShipmentFinanceInput!
) {
  infoUpdateShipmentFinance(input: $input) {
    clientMutationId
    shipment {
      ...ShipmentFinanceDetails_shipment
      ...ShipmentFinanceMetricCard_shipment
      id
    }
  }
}

fragment ShipmentFinanceDetails_shipment on Shipment {
  slug
  stage
  shipmentType
  displayCustomsType
  freeWarehousingDays
  costWarehousingPerDay
  estimatedCostWarehousing
  estimatedRevenueWarehousing
  costWarehousing
  revenueWarehousing
  estimatedCustomsDuties
  customsDuties
  estimatedCustomsVat
  customsVat
  costDischarge
  revenueDischarge
  costTransport
  revenueTransport
  costExpenses
  revenueExpenses
  costCustomsInspection
  revenueCustomsInspection
  costClimaCertificate
  revenueClimaCertificate
  costOpinion
  revenueOpinion
  costContainerXray
  revenueContainerXray
  costContainerHandling
  revenueContainerHandling
  costShipping
  revenueShipping
  costCleaning
  revenueCleaning
  costSpecialHandling
  revenueSpecialHandling
  costStorage
  revenueStorage
  costOther
  costForklift
  revenueForklift
  revenueCustomsClearance
  costCustomsClearance
  discount
  discountRemark
  receivedPayment
  totalCustomsDutiesAndVat
  totalMiscRevenue
  totalMiscCost
  totalContainerRevenue
  totalContainerCost
  totalCost
  totalRevenue
  displayExpectedHandoverDate
  displayHandoverDate
  displayDischargeDate
  shipmentValue
  shippingCost
  shipmentValueCurrency
  shipmentTypeDetails {
    portHandlingCharge
    vatChargePercent
    dutiesRatePercent
  }
  container {
    displayTerminalDate
    costXray
    costStoragePlusDemurrage
    costCleaning
    warehouseContact {
      slug
      name
      freeWarehousingDays
      costWarehousingPerDay
      costShipmentDischarge
      id
    }
    id
  }
  rateCardContact {
    slug
    name
    rateCard {
      threePackCarDischarge
      forklift
      standardCustomsClearance
      specialHandling
      freeWarehousingDays
      costWarehousing
    }
    id
  }
  customer {
    slug
    vatWarehousing
    vatRevenues
    id
  }
}

fragment ShipmentFinanceMetricCard_shipment on Shipment {
  slug
  totalCost
  totalRevenue
  totalProfit
  shipmentTypeDetails {
    vatChargePercent
  }
  estimatedRevenueWarehousing
  vatCalculator
  lexofficeInvoiceAmountPaid
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freeWarehousingDays",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "costWarehousingPerDay",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "costWarehousing",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "costCleaning",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentFinanceDetailsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateShipmentFinancePayload",
        "kind": "LinkedField",
        "name": "infoUpdateShipmentFinance",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Shipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShipmentFinanceDetails_shipment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShipmentFinanceMetricCard_shipment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentFinanceDetailsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateShipmentFinancePayload",
        "kind": "LinkedField",
        "name": "infoUpdateShipmentFinance",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Shipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shipmentType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayCustomsType",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedCostWarehousing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedRevenueWarehousing",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueWarehousing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedCustomsDuties",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customsDuties",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedCustomsVat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customsVat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costDischarge",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueDischarge",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costTransport",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueTransport",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costExpenses",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueExpenses",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costCustomsInspection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueCustomsInspection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costClimaCertificate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueClimaCertificate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costOpinion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueOpinion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costContainerXray",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueContainerXray",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costContainerHandling",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueContainerHandling",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costShipping",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueShipping",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueCleaning",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costSpecialHandling",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueSpecialHandling",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costStorage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueStorage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costOther",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costForklift",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueForklift",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revenueCustomsClearance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costCustomsClearance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discountRemark",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "receivedPayment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCustomsDutiesAndVat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalMiscRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalMiscCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalContainerRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalContainerCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayExpectedHandoverDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayHandoverDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayDischargeDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shipmentValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shippingCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shipmentValueCurrency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentTypeDetails",
                "kind": "LinkedField",
                "name": "shipmentTypeDetails",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "portHandlingCharge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vatChargePercent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dutiesRatePercent",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Container",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayTerminalDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costXray",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costStoragePlusDemurrage",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "warehouseContact",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "costShipmentDischarge",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Contact",
                "kind": "LinkedField",
                "name": "rateCardContact",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactRateCard",
                    "kind": "LinkedField",
                    "name": "rateCard",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "threePackCarDischarge",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "forklift",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "standardCustomsClearance",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "specialHandling",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Contact",
                "kind": "LinkedField",
                "name": "customer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vatWarehousing",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vatRevenues",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalProfit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatCalculator",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lexofficeInvoiceAmountPaid",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25f8e5e89a1bc81c853ac87303a6f5b5",
    "id": null,
    "metadata": {},
    "name": "ShipmentFinanceDetailsMutation",
    "operationKind": "mutation",
    "text": "mutation ShipmentFinanceDetailsMutation(\n  $input: infoUpdateShipmentFinanceInput!\n) {\n  infoUpdateShipmentFinance(input: $input) {\n    clientMutationId\n    shipment {\n      ...ShipmentFinanceDetails_shipment\n      ...ShipmentFinanceMetricCard_shipment\n      id\n    }\n  }\n}\n\nfragment ShipmentFinanceDetails_shipment on Shipment {\n  slug\n  stage\n  shipmentType\n  displayCustomsType\n  freeWarehousingDays\n  costWarehousingPerDay\n  estimatedCostWarehousing\n  estimatedRevenueWarehousing\n  costWarehousing\n  revenueWarehousing\n  estimatedCustomsDuties\n  customsDuties\n  estimatedCustomsVat\n  customsVat\n  costDischarge\n  revenueDischarge\n  costTransport\n  revenueTransport\n  costExpenses\n  revenueExpenses\n  costCustomsInspection\n  revenueCustomsInspection\n  costClimaCertificate\n  revenueClimaCertificate\n  costOpinion\n  revenueOpinion\n  costContainerXray\n  revenueContainerXray\n  costContainerHandling\n  revenueContainerHandling\n  costShipping\n  revenueShipping\n  costCleaning\n  revenueCleaning\n  costSpecialHandling\n  revenueSpecialHandling\n  costStorage\n  revenueStorage\n  costOther\n  costForklift\n  revenueForklift\n  revenueCustomsClearance\n  costCustomsClearance\n  discount\n  discountRemark\n  receivedPayment\n  totalCustomsDutiesAndVat\n  totalMiscRevenue\n  totalMiscCost\n  totalContainerRevenue\n  totalContainerCost\n  totalCost\n  totalRevenue\n  displayExpectedHandoverDate\n  displayHandoverDate\n  displayDischargeDate\n  shipmentValue\n  shippingCost\n  shipmentValueCurrency\n  shipmentTypeDetails {\n    portHandlingCharge\n    vatChargePercent\n    dutiesRatePercent\n  }\n  container {\n    displayTerminalDate\n    costXray\n    costStoragePlusDemurrage\n    costCleaning\n    warehouseContact {\n      slug\n      name\n      freeWarehousingDays\n      costWarehousingPerDay\n      costShipmentDischarge\n      id\n    }\n    id\n  }\n  rateCardContact {\n    slug\n    name\n    rateCard {\n      threePackCarDischarge\n      forklift\n      standardCustomsClearance\n      specialHandling\n      freeWarehousingDays\n      costWarehousing\n    }\n    id\n  }\n  customer {\n    slug\n    vatWarehousing\n    vatRevenues\n    id\n  }\n}\n\nfragment ShipmentFinanceMetricCard_shipment on Shipment {\n  slug\n  totalCost\n  totalRevenue\n  totalProfit\n  shipmentTypeDetails {\n    vatChargePercent\n  }\n  estimatedRevenueWarehousing\n  vatCalculator\n  lexofficeInvoiceAmountPaid\n}\n"
  }
};
})();
(node as any).hash = 'b094e161560a27a82b65967f295341a5';
export default node;
